import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { FormConfiguration } from 'src/app/core/components/dynamic-form/models/form-config';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { Person } from 'src/app/lem/models/person/person';
import { PersonType } from 'src/app/lem/models/person/person-type';
import { NewpersonFormComponent } from '../../component/newperson-form/newperson-form.component';
import { PersonService } from '../../services/person.service';
import { searchConfigLegal } from './form-config/search-config-legal';
import { searchConfigPhysical } from './form-config/search-config-physical';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import {PaginatedResponse} from '../../../../models/common/paginated-response';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'main [person]',
  templateUrl: './person.component.html',
  styleUrls: ['./person.component.css'],
  host:{'[attr.id]': '\'content\''}
})
export class PersonComponent implements OnInit {

  formFieldsPhysical: QuestionBase[] = searchConfigPhysical;
  formFieldsLegal: QuestionBase[] = searchConfigLegal;
  personTypeSelect = null;
  formConfiguration: FormConfiguration = {
    buttons: [
      {
        bg: "",
        width: "",
        type: "submit",
        title: "Ricerca",
        class: "btn-primary",
      },
      {
        bg: "",
        width: "",
        type: "reset",
        title: "Reset",
        class: "btn-secondary",
      }
    ]
  }

  personList : PaginatedResponse<Person> = null;
  personType : PersonType[];
  lastSearch = null;
  pagable: Pagable = new Pagable();
  resetCurrentPage: boolean = false;

  constructor(
    private modal : DialogService,
    private personService : PersonService,
    private viewManager : ViewManagerService
  ) {}


  ngOnInit() {

    this.viewManager.svuotaMenu();
    this.personService.getAllType().subscribe((types)=>{this.personType = types;})

    this.personService.RefreshRequired$.subscribe(()=>(this.getAllPersons()));

    this.getAllPersons();

  }

  // ADD PERSON MODAL   SEND PERSON TYPES
  addPerson () {
  const ref = this.modal.open(NewpersonFormComponent,{ data : {
    personTypes : this.personType,
    style: {width: "50%"},
    formSettings : {
      formEdit : false,
      formData : ""
    }
  }});
    ref.afterClosed.subscribe((person)=>{
      if(!person || person.closeEvent) return
      this.personService.addPerson(this.personService.personTypeSwitcher(person)).subscribe();
    });
  }

  onEditPerson (person : Person) {
    const ref = this.modal.open(NewpersonFormComponent,{
      data : {
        personTypes : this.personType,
        style: {width: "50%"},
        formSettings : {
          formEdit : true,
          formData : person
        }
      }
    })
    this.modalCloseEvent(ref);
  }

  private getAllPersons () {
    this.personService.searchPersonPaginated(null,this.pagable).subscribe({
      next: (data) => {
        this.personList = data;
      },
      error: (error) => { console.log(JSON.stringify(error))}
    });
  }

  onDeletePerson (person : Person) {
    let name  = (person.name)?  person.name : person.firstName;

    const ref = this.modal.open(ConfirmModalComponent,{
      data : {
        modalConfirm:{

          text:"Eliminare la Persona  " + name + "?" ,
          data : person,
        },
        style : {
          width : '30%'
        },
        title:"Eliminazione Persona",
      }
    })
    this.modalCloseEvent(ref);
  }

  onSearch(value,personType){
    this.pagable.page = 0;
    this.resetCurrentPage = true;
    this.sendSearch(value,personType);
  }

  sendSearch (value,personType) {
    this.lastSearch = value;
    // this.personTypeSelect = personType;
    this.personService.searchPersonPaginated(this.cleanEmpty({...value , type: personType}),this.pagable).subscribe({
      next: (data) => {
        this.personList = data;
      },
      error: (error) => { console.log(JSON.stringify(error))}
    });
  }

  // MODAL EVENT MANAGER
  modalCloseEvent (ref: DialogRef) {
    ref.afterClosed.pipe(
      filter(response => response)
    ).subscribe((data)=>{
      if(data.edit){
        this.personService.editPerson(this.personService.personTypeSwitcher(data.data)).subscribe();
      }else if(data.modalEvent){
        this.personService.deletePerson(data.data).subscribe();
      };
    })
  }

  cleanEmpty (obj) {
    for (let propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }

  resetForm(){
    this.personTypeSelect = null;
    this.pagable.page = 0;
  }

  updateList(pagination?: Pagination){
    if(pagination) {
      this.pagable.size = pagination.getItemsPerPage();
      this.pagable.page = pagination.getCurrentPage();
    }
    this.personTypeSelect ? this.sendSearch(this.lastSearch,this.personTypeSelect.id) : this.getAllPersons();
    this.resetCurrentPage = false;

  }


}
